module.exports = __webpack_public_path__ + "static/media/Profile.23cf16c3.svg";